import React from "react";
import { useNavigate } from "react-router";
import ReportTemplate2 from "../reportTemplate2";
import dayjs from "dayjs";
import { Button } from "reactstrap";
import { Icon } from "../../../components/Component";

function MaterialsToSiteReport() {
  const navigate = useNavigate();
  const columns: any = [
    {
      title: "Material Issue Number",
      key: "issueNumber",
      dataIndex: "issueNumber",
      width: 200,
    },
    {
      title: "Material HandOver Number",
      key: "handoverNumber",
      dataIndex: "handoverNumber",
      width: 200,
    },

    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "Contractor",
      dataIndex: "contractorName",
      key: "contractorName",
      width: 200,
    },
    {
      title: "Location",
      key: "location",
      width: 150,
      render: (text: any, record: any) => {
        // For Villa level, only show subUnitName as villa number
        if ((window as any).workBoqData?.workLevel === "Villa") {
          return record.subUnitName || "-";
        }

        // For other levels, build location path
        const location = [];
        if (record.unitName) location.push(record.unitName);
        if (record.floor) location.push(record.floor);
        if (record.subUnitName) location.push(record.subUnitName);
        return (
          <>
            <div className="fw-bold">{location.join(" / ") || "-"}</div>
            <div className="small">
              {(record.locationName && `${record.locationName}`) || ""}
            </div>
          </>
        );
      },
    },
    {
      title: "Created By",
      key: "createdUserName",
      dataIndex: "createdUserName",
      width: 100,
    },
    {
      title: "Creation Date",
      key: "createdAt",
      dataIndex: "createdAt",
      width: 100,
      render: (text: string) => dayjs(text).format("DD-MMM-YYYY"),
    },
    {
      title: "HandOver Status",
      key: "handoverStatus",
      dataIndex: "handoverStatus",
      width: 100,
    },
    {
      title: "Action",
      key: "operation",
      // fixed: "right",
      width: 150,
      render: (text: any, record: any, index: any) => (
        <>
          <Button
            size="sm"
            color=""
            onClick={() => {
              navigate(
                `/view-material-issue-details/${record.materialIssueId}`,
                {
                  state: {
                    previousPath: `/inventory-materials-to-site-reports-list`,
                  },
                }
              );
            }}
          >
            <Icon name="focus" />
          </Button>
        </>
      ),
    },
  ];
  return (
    <ReportTemplate2
      pageTitle="Materials Issued To Site"
      pageDescription="Record of materials dispatched to construction sites"
      moduleKey="materialsIssuedToSite"
      columns={columns}
      filtersOption={{
        site: true,
        contractor: true,
        tower: true,
        floor: true,
        flat: true,
        location: true,
        // dateRange: true,
      }}
      previousPath="/view-inventory-reports"
    />
  );
}

export default MaterialsToSiteReport;
